export default __webpack_public_path__ + "static/media/Google.c7179514.svg";